<template>
  <!-- /restaurateurs-bg-section start -->
  <section class="restaurateurs-bg">
    <div class="row">
      <div class="col-lg-6 col-md-12 p-0">
        <div class="restaurateurs-img">
          <img src="@/assets/img/main-img.jpg" class="img-fluid" alt="img" />
        </div>
      </div>
      <div
        class="col-lg-6 col-md-12 p-0 restaurateurs-main-bg d-flex align-items-center"
      >
        <div class="right-content">
          <div class="restaurateurs-content section-heading-seven">
            <img
              src="@/assets/img/heading-logo-small.png"
              class="img-fluid"
              alt="img"
            />
            <h2>Restaurateurs join us</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit,eiusmod
              tempor incididunt ullamco minim ut labore et dolore magna aliqua.
            </p>
            <router-link to="signup" class="btn"
              >Join Us <i class="fa-solid fa-arrow-right"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /restaurateurs-bg-section end -->
  <!-- Restaurant Section -->
  <section class="latest-restaurant-section">
    <div class="container">
      <div class="section-heading-two mb-0">
        <div class="row">
          <div class="col-md-8">
            <div
              class="section-heading section-heading-seven d-flex align-items-center aos"
              data-aos="fade-up"
            >
              <div class="heading-img">
                <img
                  src="@/assets/img/heading-logo.png"
                  class="img-fluid m-0"
                  alt="img"
                />
              </div>
              <div>
                <h2>Latest Restaurant</h2>
                <p>What are you interested near you.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="dishes-box aos" data-aos="fade-up">
              <div class="dishes-img">
                <a href="#">
                  <img
                    src="@/assets/img/latest/latest-restaurant-1.jpg"
                    class="img-fluid"
                    alt="img"
                  />
                </a>
                <div class="feature-content justify-content-end">
                  <span class="featured-text">Featured</span>
                </div>
                <div class="fav-item justify-content-end">
                  <a href="javascript:void(0)" class="fav-icon">
                    <i class="fa-regular fa-bookmark"></i>
                  </a>
                </div>
              </div>
              <div class="dishes-content">
                <div class="dishes-inner">
                  <div class="author-img-new">
                    <div class="inner-img">
                      <img
                        src="@/assets/img/profiles/avatar-01.jpg"
                        class="img-fluid"
                        alt="img"
                      />
                    </div>
                  </div>
                  <p class="title">China</p>
                  <h5>
                    <a href="javascript:void(0);">
                      Fast-casual dining <i class="fa-solid fa-circle-check"></i
                    ></a>
                  </h5>
                  <div class="dishes-review">
                    <h6><i class="fa-regular fa-clock"></i>Open</h6>
                    <h6 class="review-color">
                      5.0<i class="fa-solid fa-star review-color"></i>
                      <span class="img-fluid">10(Reviews)</span>
                    </h6>
                  </div>
                </div>
                <div class="dishes-footer">
                  <div class="landmark">
                    <h5>
                      <i class="feather-map-pin"></i>
                      United States
                    </h5>
                  </div>
                  <div class="amount">
                    <h5>
                      $300
                      <span>/ hour</span>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="dishes-box aos" data-aos="fade-up">
              <div class="dishes-img">
                <a href="#">
                  <img
                    src="@/assets/img/latest/latest-restaurant-2.jpg"
                    class="img-fluid"
                    alt="img"
                  />
                </a>
                <div class="feature-content justify-content-end">
                  <span class="featured-text">Featured</span>
                </div>
                <div class="fav-item justify-content-end">
                  <a href="javascript:void(0)" class="fav-icon">
                    <i class="fa-regular fa-bookmark"></i>
                  </a>
                </div>
              </div>
              <div class="dishes-content">
                <div class="dishes-inner">
                  <div class="author-img-new">
                    <div class="inner-img">
                      <img
                        src="@/assets/img/profiles/avatar-02.jpg"
                        class="img-fluid"
                        alt="img"
                      />
                    </div>
                  </div>
                  <p class="title">Japan</p>
                  <h5>
                    <a href="javascript:void(0);">
                      Family-style dining
                      <i class="fa-solid fa-circle-check"></i
                    ></a>
                  </h5>
                  <div class="dishes-review">
                    <h6><i class="fa-regular fa-clock"></i>Open</h6>
                    <h6 class="review-color">
                      5.0<i class="fa-solid fa-star review-color"></i>
                      <span class="img-fluid">10(Reviews)</span>
                    </h6>
                  </div>
                </div>
                <div class="dishes-footer">
                  <div class="landmark">
                    <h5>
                      <i class="feather-map-pin"></i>
                      Tokyo
                    </h5>
                  </div>
                  <div class="amount">
                    <h5>
                      $200
                      <span>/ hour</span>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="dishes-box aos" data-aos="fade-up">
              <div class="dishes-img">
                <a href="#">
                  <img
                    src="@/assets/img/latest/latest-restaurant-3.jpg"
                    class="img-fluid"
                    alt="img"
                  />
                </a>
                <div class="feature-content justify-content-end">
                  <span class="featured-text">Featured</span>
                </div>
                <div class="fav-item justify-content-end">
                  <a href="javascript:void(0)" class="fav-icon">
                    <i class="fa-regular fa-bookmark"></i>
                  </a>
                </div>
              </div>
              <div class="dishes-content">
                <div class="dishes-inner">
                  <div class="author-img-new">
                    <div class="inner-img">
                      <img
                        src="@/assets/img/profiles/avatar-03.jpg"
                        class="img-fluid"
                        alt="img"
                      />
                    </div>
                  </div>
                  <p class="title">England</p>
                  <h5>
                    <a href="javascript:void(0);">
                      Fine dining
                      <i class="fa-solid fa-circle-check"></i>
                    </a>
                  </h5>
                  <div class="dishes-review">
                    <h6><i class="fa-regular fa-clock"></i>Open</h6>
                    <h6 class="review-color">
                      3.0<i class="fa-solid fa-star review-color"></i>
                      <span class="img-fluid">8(Reviews)</span>
                    </h6>
                  </div>
                </div>
                <div class="dishes-footer">
                  <div class="landmark">
                    <h5>
                      <i class="feather-map-pin"></i>
                      Germany
                    </h5>
                  </div>
                  <div class="amount">
                    <h5>
                      $300
                      <span>/ hour</span>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="dishes-box aos" data-aos="fade-up">
              <div class="dishes-img">
                <a href="#">
                  <img
                    src="@/assets/img/latest/latest-restaurant-4.jpg"
                    class="img-fluid"
                    alt="img"
                  />
                </a>
                <div class="feature-content justify-content-end">
                  <span class="featured-text">Featured</span>
                </div>
                <div class="fav-item justify-content-end">
                  <a href="javascript:void(0)" class="fav-icon">
                    <i class="fa-regular fa-bookmark"></i>
                  </a>
                </div>
              </div>
              <div class="dishes-content">
                <div class="dishes-inner">
                  <div class="author-img-new">
                    <div class="inner-img">
                      <img
                        src="@/assets/img/profiles/avatar-05.jpg"
                        class="img-fluid"
                        alt="no-img"
                      />
                    </div>
                  </div>
                  <p class="title">Australia</p>
                  <h5>
                    <a href="javascript:void(0);">
                      Casual dining
                      <i class="fa-solid fa-circle-check"></i>
                    </a>
                  </h5>
                  <div class="dishes-review">
                    <h6><i class="fa-regular fa-clock"></i>Open</h6>
                    <h6 class="review-color">
                      4.0<i class="fa-solid fa-star review-color"></i>
                      <span>9(Reviews)</span>
                    </h6>
                  </div>
                </div>
                <div class="dishes-footer">
                  <div class="landmark">
                    <h5>
                      <i class="feather-map-pin"></i>
                      China
                    </h5>
                  </div>
                  <div class="amount">
                    <h5>
                      $250
                      <span>/ hour</span>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Restaurant Section -->
</template>
